import { useFilterEmployeeOverageContext } from "./filter-employee-overage.context";

export function FilterEmployeeOverage() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterEmployeeOverageContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}